import { DIALOG_TYPE, LAUNCH_CALLER, LayoutConfig } from '@spartacus/storefront';
import { ExcludeArticlesModalComponent } from './exclude-articles-modal.component';

export const excludeArticlesModalLayoutConfig: LayoutConfig = {
  launch: {
    [LAUNCH_CALLER.EXCLUDE_ARTICLES]: {
      inlineRoot: true,
      component: ExcludeArticlesModalComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
  },
};
